import { createWsActions, WsPrefixes, send } from '@skynet/data-ws-core';
import type { WsCommand } from '@skynet/data-ws-core';

export const prefix = WsPrefixes.authPrefix;

const authActions = createWsActions(prefix);

export const {
  actionConnect: actionAuthConnect,
  actionOnOpen: actionAuthOnOpen,
  actionDisconnect: actionAuthDisconnect,
  actionOnClose: actionAuthOnClose,
  actionOnClosed: actionAuthOnClosed,
  actionSend: actionAuthSend,
  actionOnMessage: actionAuthOnMessage,
  actionOnBroken: actionAuthOnBroken,
  actionOnReconnectBegin: actionAuthOnReconnectBegin,
  actionOnReconnectAttempt: actionAuthOnReconnectAttempt,
  actionOnReconnected: actionAuthOnReconnected,
  actionOnError: actionAuthOnError,
} = authActions;

export { authActions };

/** Dispatches a WS send action with the Auth prefix. */
export const wsAuthSend = (message: WsCommand) => send(message, prefix);
